import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-base-100 hover:bg-base-200 
                 text-base-content transition-colors duration-150 
                 focus:outline-none focus:ring-2 focus:ring-primary-500 
                 focus:ring-offset-2 focus:ring-offset-base-100"
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {theme === 'dark' ? (
        <Sun 
          className="w-5 h-5 text-accent-600 hover:rotate-12 transition-transform duration-200" 
          aria-hidden="true"
        />
      ) : (
        <Moon 
          className="w-5 h-5 text-base-600 transition-transform duration-200" 
          aria-hidden="true"
        />
      )}
    </button>
  );
}